import { useEffect } from "react";
import { useToastNotifications } from "@/shared/coralreef";
import { setToastSink } from "@/shell-handle/notify";

export function ToastBridge() {
  const { addToast } = useToastNotifications();

  useEffect(() => {
    setToastSink((msg, level) => addToast(msg, level));
    return () => setToastSink(null);
  }, [addToast]);

  return null;
}
